<template>
<div class="chapter">
<div class="inner_page">
<p style="margin: 0; padding: 0; text-align: center"><img alt="" src="images/title1.jpg" style="padding: 0; margin: 0; height:100%;"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// f003.vue?737c83fd